import { SupplierMaster } from '../models';
import {Injectable} from '@angular/core';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient} from '@angular/common/http';
import {Burly} from 'kb-burly';
import {Observable} from 'rxjs';
import {RequestQueryBuilder, SCondition} from '@nestjsx/crud-request';
import {ManyResponse} from '../../../responses';
import {Facet} from 'ngx-mat-facet-search';
import {SupplierMasterType} from '../models';

@Injectable({
  providedIn: 'root'
})
export class TorchSupplierMasterService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  public static buildTextFilter(facet: Facet, columnName: string) {
    const returnValue = {};

    const facetOption = facet.values[0];

    if (facetOption.type === 'equal') {
      returnValue[columnName] = facetOption.value;
    } else if (facetOption.type === 'contains') {
      returnValue[columnName] = {
        $cont: facetOption.value
      };
    } else if (facetOption.type === 'startsWith') {
      returnValue[columnName] = {
        $starts: facetOption.value
      };
    } else if (facetOption.type === 'endsWith') {
      returnValue[columnName] = {
        $ends: facetOption.value
      };
    }

    return returnValue;
  }

  public querySuppliers(pageSize: number = 50,
                        currentPage: number = 0,
                        sortDirection: 'ASC' | 'DESC' | '' = 'ASC',
                        sortBy: string = 'id',
                        filters: SCondition | null): Observable<ManyResponse<SupplierMaster>> {
    const qb = RequestQueryBuilder.create();

    qb.setPage(currentPage + 1).setLimit(pageSize);

    if (!!sortDirection) {
      qb.sortBy({field: sortBy, order: sortDirection});
    }

    if (!!filters) {
      qb.search(filters);
    }

    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/supplier-master')
      .appendRawQueryString(qb.query(false))
      .get;

    return this.httpClient.get<ManyResponse<SupplierMaster>>(endpoint);
  }

  public getSupplierByFsc(fsc: string,
                          filter?: string | string[]): Observable<SupplierMaster[]> {

    let finalURL;
    const endpointURL = Burly(this.config.rootUrl)
    .addSegment('/supplier-master')
    .addSegment('/by-fsc/' + fsc);

    finalURL = endpointURL.get;

    if (filter) {
      if (filter instanceof Array) {
        if (filter.length > 0) {
          filter.forEach((filterValue, index) => {
            if (index === 0) {
              finalURL = `${finalURL}?filters=${encodeURIComponent(filterValue)}`;
            } else {
              finalURL = `${finalURL}&filters=${encodeURIComponent(filterValue)}`;
            }
          });
        }
      } else {
        finalURL = `${finalURL}?filters=${encodeURIComponent(filter)}`;
      }
    }

    return this.httpClient.get<SupplierMaster[]>(finalURL);
  }

  public updateUmbrellaCorp(vendor: SupplierMaster) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/supplier-master')
      .addSegment('/' + vendor.id)
      .get;

    return new Promise((resolve, reject) => {
      this.httpClient.patch(endpointURL, vendor)
        .subscribe((response) => {
          resolve(response);
        }, reject);
    });
  }

  public getSupplierTypeByFsc(fsc: string,
                              filter?: string | string[]): Observable<SupplierMasterType[]> {

    let finalURL;
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/supplier-master-type')
      .addSegment('/by-fsc/' + fsc);

    finalURL = endpointURL.get;

    if (filter) {
      if (filter instanceof Array) {
        if (filter.length > 0) {
          filter.forEach((filterValue, index) => {
            if (index === 0) {
              finalURL = `${finalURL}?filters=${encodeURIComponent(filterValue)}`;
            } else {
              finalURL = `${finalURL}&filters=${encodeURIComponent(filterValue)}`;
            }
          });
        }
      } else {
        finalURL = `${finalURL}?filters=${encodeURIComponent(filter)}`;
      }
    }

    return this.httpClient.get<SupplierMasterType[]>(finalURL);
  }
}
